import React from 'react';
import ScrollAnim from 'rc-scroll-anim';
import TweenOne from 'rc-tween-one';

import FeatureIcon from './feature-icon';
import Button from '../../components/button';

import handleChat from '../../utils/handle-chat';

const ScrollOverPack = ScrollAnim.OverPack;

const chat = [
  {
    name: '聊天链接',
    price: '10元/月'
  },
  {
    name: '快捷回复',
    price: '10元/月'
  },
  {
    name: '消息预知',
    price: '10元/月'
  },
  {
    name: '询前表单',
    price: '10元/月'
  },
  {
    name: '拉黑访客',
    price: '10元/月'
  },
  {
    name: '对话协作',
    price: '10元/月'
  },
  {
    name: '消息撤回',
    price: '10元/月'
  }
];
const customer = [
  {
    name: '顾客中心基础',
    price: '20元/月'
  },
  {
    name: '顾客中心增强',
    price: '20元/月'
  },
  {
    name: '访客中心',
    price: '20元/月'
  }
];
const advanced = [
  {
    name: '智能引导',
    price: '20元/月'
  },
  {
    name: '报表',
    price: '20元/月'
  },
  {
    name: '数据大屏',
    price: '20元/月'
  },
  {
    name: '聊天机器人',
    price: '150元/月'
  }
];
const more = [
  {
    name: 'API',
    price: '10元/月'
  },
  {
    name: '独立品牌',
    price: '10元/月'
  }
];

const f = {
  y: '+=50',
  opacity: 0,
  type: 'from'
};

class FeatureMore extends React.Component {
  render() {
    return (
      <>
        <ScrollOverPack playScale={0.15}>
          <TweenOne animation={f} className="detail-3-chat panel">
            <h3>对话功能</h3>
            <div>
              {chat.map((item, i) => (
                <div key={i} className="icon-more">
                  <FeatureIcon type={`p3i${`${i + 1}`.padStart(2, '0')}`} {...item} />
                </div>
              ))}
            </div>
            <div>
              <Button onClick={() => handleChat('咨询对话功能', ['d3'])}>查看更多</Button>
            </div>
          </TweenOne>
        </ScrollOverPack>

        <ScrollOverPack playScale={0.15}>
          <TweenOne animation={f} className="detail-3-customer panel">
            <h3>客户管理</h3>
            <div>
              {customer.map((item, i) => (
                <div key={i} className="icon-more">
                  <FeatureIcon type={`p4i${`${i + 1}`.padStart(2, '0')}`} {...item} />
                </div>
              ))}
            </div>
            <div>
              <Button onClick={() => handleChat('咨询客户管理', ['d4'])}>查看更多</Button>
            </div>
          </TweenOne>
        </ScrollOverPack>

        <ScrollOverPack playScale={0.15}>
          <TweenOne animation={f} className="detail-3-advanced panel">
            <h3>高级应用</h3>
            <div>
              {advanced.map((item, i) => (
                <div key={i} className="icon-more">
                  <FeatureIcon type={`p5i${`${i + 1}`.padStart(2, '0')}`} {...item} />
                </div>
              ))}
            </div>
            <div>
              <Button onClick={() => handleChat('咨询高级应用', ['d5'])}>查看更多</Button>
            </div>
          </TweenOne>
        </ScrollOverPack>

        <ScrollOverPack playScale={0.15}>
          <TweenOne animation={f} className="detail-3-more panel">
            <h3>补充功能</h3>
            <div>
              {more.map((item, i) => (
                <div key={i} className="icon-more">
                  <FeatureIcon type={`p6i${`${i + 1}`.padStart(2, '0')}`} {...item} />
                </div>
              ))}
            </div>
            <div>
              <Button onClick={() => handleChat('咨询补充功能', ['d6'])}>查看更多</Button>
            </div>
          </TweenOne>
        </ScrollOverPack>
      </>
    );
  }
}

export default FeatureMore;
